import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Plus, Search, X } from "lucide-react";
import PropTypes from "prop-types";
import React from "react";

const AddDocumentTypeModal = ({ isOpen, onClose, onSelectTemplate, onCreateNew }) => {
  return (
    <Dialog open={isOpen} onOpenChange={(next) => !next && onClose()}>
      <DialogContent size="sm" hideCloseButton className="gap-0 p-0">
        <DialogHeader className="flex-row items-center justify-between space-y-0 border-b p-4 text-left">
          <DialogTitle className="text-lg font-medium">Add Document Type</DialogTitle>
          <DialogClose className="text-text-disabled hover:text-muted-foreground">
            <X className="h-5 w-5" />
          </DialogClose>
        </DialogHeader>

        <div className="space-y-4 p-4">
          <button
            onClick={onSelectTemplate}
            className="w-full rounded-lg border p-6 text-left hover:bg-surface-subtle focus-visible:shadow-focus"
          >
            <div className="flex items-center space-x-4">
              <div className="rounded-lg bg-surface-sunken p-2">
                <Search className="h-6 w-6 text-muted-foreground" />
              </div>
              <div>
                <h3 className="font-medium">Search existing document types</h3>
                <p className="text-sm text-muted-foreground">
                  Find and customize pre-built document types
                </p>
              </div>
            </div>
          </button>

          <button
            onClick={onCreateNew}
            className="w-full rounded-lg border p-6 text-left hover:bg-surface-subtle focus-visible:shadow-focus"
          >
            <div className="flex items-center space-x-4">
              <div className="rounded-lg bg-surface-sunken p-2">
                <Plus className="h-6 w-6 text-muted-foreground" />
              </div>
              <div>
                <h3 className="font-medium">Create from scratch</h3>
                <p className="text-sm text-muted-foreground">Build a custom document type</p>
              </div>
            </div>
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

AddDocumentTypeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelectTemplate: PropTypes.func.isRequired,
  onCreateNew: PropTypes.func.isRequired,
};

export default AddDocumentTypeModal;
